/**
 * define websocket endpoint
 * @param {String} options.clientId
 * @param {String} options.userId
 * @return {String}
 */
export const getWebsocketEndpoint = ({ clientId, userId }) =>
  import.meta.env.VITE_WEBSOCKET_ENDPOINT + `/ws/v1/insights/${clientId}/${userId}`;
